import React, { memo, useContext } from "react";
import { Row, Col, Input, Typography } from "antd";
import { campaignCreationContext } from "@ts/constants";

const { Text } = Typography;

const HeaderSection = memo(() => {
    const { clusterName, setClusterName } = useContext(campaignCreationContext);
    return (
        <Row align="middle" className="border-bottom" style={{ padding: 20 }}>
            <Col span={3}>
                <Text strong className="w-100">
                    Cluster Name
                </Text>
            </Col>
            <Col span={21}>
                <Input
                    className="border"
                    style={{ maxWidth: "488px" }}
                    value={clusterName}
                    onChange={(e) => setClusterName(e.target.value)}
                />
            </Col>
        </Row>
    );
});

export default HeaderSection;

